import React from 'react';
import PropTypes from 'prop-types';

import { IoMdCalendar } from 'react-icons/io';
import { format, parseISO } from 'date-fns';

import { Container, Text, DateText } from './styles';

function DateComponent({ date }) {
  const dateParsed = format(parseISO(date), 'dd/MM/yyyy');

  return (
    <Container>
      <IoMdCalendar />
      <Text bold>Data</Text>
      <DateText>{dateParsed}</DateText>
    </Container>
  );
}

DateComponent.propTypes = {
  date: PropTypes.string.isRequired,
};

export default DateComponent;
